/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes, { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { isEmpty } from '../../../utils/object';
import { dateMMMMDDYYYY } from '../../../utils/dateString';

const styles = (theme) => ({
    orderRow: {
        backgroundColor: theme.palette.white,
        margin: '12px 0',
        padding: '0px 12px',
    },
    orderHeader: {
        fontSize: 14,
        // xbackgroundColor: theme.palette.orderDetail.orderHeaderBg,
        padding: '0px 12px !important',
    },
    orderHeaderInner: {
        padding: 24,
    },
    pageHeading: {
        fontWeight: 700,
        textTransform: 'uppercase',
        fontSize: '16px !important',
        color: theme.palette.myAccount.contentGridBorder,
    },
    pageHeadingContent: {
        fontSize: '16px !important',
        fontWeight: 700,
    },
    pageHeadingInner: {
        textAlign: 'right',
    },
});
const DesktopOrderNumber = ({ orderDetailById, classes }) => {
    const firstOrderDetailById = orderDetailById[0];
    let orderDate = '';
    let orderNumber = '';
    try {
        ({ orderNumber, orderDate } = firstOrderDetailById);
        // eslint-disable-next-line no-empty
    } catch (ex) {}
    const orderDateString = dateMMMMDDYYYY(orderDate);
    if (isEmpty(orderDetailById)) return null;

    return (
        <>

            <Grid className={`gray-bg ${classes.orderHeaderInner}`} container>
                <Grid item xs={4}>
                    <span className={classes.pageHeading}>Order #: </span>
                    <span className={classes.pageHeadingContent}>{orderNumber}</span>
                </Grid>
                <Grid item xs={4}>
                    <div className=" display-none">
                        <span className={classes.pageHeading}>
                            Replacement for:{' '}
                        </span>
                        <span className={classes.pageHeadingContent}>{orderNumber}</span>
                    </div>
                </Grid>
                <Grid item xs={4}>
                    <span className={classes.pageHeading}>Order Date: </span>
                    <span className={classes.pageHeadingContent}>{orderDateString}</span>
                </Grid>
            </Grid>

        </>
    );
};

DesktopOrderNumber.defaultProps = {
    orderDetailById: [],
};

DesktopOrderNumber.propTypes = {
    orderDetailById: PropTypes.array,
    classes: object.isRequired,
};

export default withStyles(styles)(DesktopOrderNumber);
